<div class="ds-info mb-3" *ngIf="showVisibleInfo$ | async" i18n="@@headline.voucher.displayInfo">
  Das Gutscheinfeld ist in den Produkteinstellungen des ausgewählten Produktes als versteckt gekennzeichnet und wird
  daher auf dem Bestellformular nicht angezeigt.
</div>

<fieldset *ngIf="isEnabled$ | async">
  <div *ngIf="formGroup$ | async as formGroup" [attr.data-e2e]="'form:voucher'">
    <ng-template #widgetTitle>
      <span i18n="@@headline.voucher"> Gutschein </span>
    </ng-template>

    <ng-template #widgetNotCollapsable>
      <div class="label-container">
        <ng-container *ngTemplateOutlet="widgetTitle"></ng-container>
      </div>
    </ng-template>

    <a
      class="label-container"
      *ngIf="_displayStatus() === 'collapsable'; else widgetNotCollapsable"
      (click)="openToggle.set(!openToggle())"
    >
      <ng-container *ngTemplateOutlet="widgetTitle"></ng-container>
      <span
        class="icon ml-2 mb-1 pi"
        [ngClass]="{
          'pi-chevron-up': openToggle(),
          'pi-chevron-down': openToggle() === false
        }"
      >
      </span>
    </a>

    <ng-template #enter>
      <div [formGroup]="formGroup" class="mt-4" [orderformBreakpoint]="{ '620': 'row-view' }">
        <div [attr.data-e2e]="'form:field:voucher'">
          <div class="d-flex flex-column grow-auto">
            <div class="d-flex flex-row input-container">
              <input
                [readOnly]="isReadyOnly$ | async"
                type="text"
                class="form-control mx-0"
                formControlName="voucherCode"
                i18n-placeholder="@@address.label.voucher_input_label"
                placeholder="Gutscheincode (optional)"
                (keyup.enter)="apply(formGroup)"
                (focusout)="apply(formGroup)"
              />

              <div class="button-wrapper mr-0">
                <button
                  [disabled]="isReadyOnly$ | async"
                  class="secondary ds-button"
                  i18n="@@address.label.voucher_apply"
                >
                  <div class="button-inner"> Anwenden </div>
                </button>
              </div>
            </div>

            <div class="mt-3" *ngIf="successMessage$ | async as successMessage">
              <div class="success-message">
                {{ successMessage }}
              </div>
            </div>

            <div class="mt-3" *ngIf="validate$ | async as valid">
              <orderform-input-errors [error]="valid"></orderform-input-errors>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-container *ngIf="_displayStatus() === 'collapsable'; else enter">
      <div *ngIf="isOpen()" [@slideInOut]>
        <ng-container *ngTemplateOutlet="enter"></ng-container>
      </div>
    </ng-container>
  </div>
</fieldset>
